import "./ObjectiveCard.scss"
import React from 'react'
import { classNames } from "primereact/utils"
import parse from "html-react-parser"

function ObjectiveCard({ className, heading, content, count }) {
    return (
        <div className={classNames('ObjectiveCard', className)}>
            <div className="CardContainer relative px-4 py-3 h-full">
                <h3 className='CardHeading text-base font-normal ml-5'>{heading}</h3>
                <div className="TextArea mt-4 text-sm font-normal mb-3">
                    {parse(content)}
                </div>
                <div className="Count absolute top-0 left-0 font-semibold text-2xl px-4 py-2">
                    {count}
                </div>
            </div>
        </div>
    )
}

export default ObjectiveCard